// store.js
import {ref} from 'vue'

export const store = ref({
    isShowAlert: false,
    alertMessage: '',
    alertType: '',
})
